import { render } from "./SchemaError.vue?vue&type=template&id=41b1e76e"
import script from "./SchemaError.vue?vue&type=script&lang=js"
export * from "./SchemaError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__